import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import snakeCaseKeys from 'snakecase-keys';

import { sendAlert } from '../../actions/utils';
import { SimpleCenteredModal } from '../../components';
import { updateLeadRequest } from '../../requests/lead';
import { updateAdminLeadRequest } from '../../requests/admin/lead';
import LeadForm from '../../components/Lead/LeadForm';

const LeadEdit = ({ lead, setMoreData, modalShow, handleModalClose, fromAdmin, onStep }) => {
  const modelUrl = fromAdmin ? '/admin/leads' : '/leads';
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSuccessUpdate = () => {
    dispatch(sendAlert({ kind: 'success', message: 'Oportunidad actualizada con éxito' }));
    history.push(`${modelUrl}/${lead.id}`);
    setMoreData(m => !m);
  };

  const handleUpdateRequest = (values, setSubmitting) => {
    const { quotationRequestFile } = values.lead;
    const sendParams = snakeCaseKeys(values);
    sendParams.lead.quotation_request_file = quotationRequestFile;
    const updateRequest = fromAdmin ? updateAdminLeadRequest : updateLeadRequest;

    updateRequest(lead.id, {
      dispatch,
      params: sendParams,
      formData: true,
      successCallback: handleSuccessUpdate,
      callback: () => setSubmitting(false)
    });
  };

  return (
    <SimpleCenteredModal
      size="xl"
      title="Editar información de cobertura"
      show={modalShow}
      onHide={handleModalClose}
      body={
        <LeadForm
          onStep={onStep}
          action="edit"
          fromAdmin={fromAdmin}
          modelUrl={modelUrl}
          lead={lead}
          formRequest={handleUpdateRequest}
          onHide={handleModalClose}
        />
      }
    />
  );
};

export default LeadEdit;
